// extracted by mini-css-extract-plugin
export default {"slotsWrapper":"projectSlots_slotsWrapper__sxQo-","teamIcon":"projectSlots_teamIcon__fyu6R"};